export function updatePollObject(poll) {
  const { choices, type } = poll;
  return {
    choices: choices.length,
    type
  };
}

export function updateSurveyObject(survey) {
  const updatedQuestions = survey.questions.map((q) => ({
    choices: q.choices.length,
    type: q.type
  }));
  return {
    ...survey,
    questions: updatedQuestions
  };
}

export function updateVirtualEventObject(obj) {
  const { name, email, ...rest } = obj;
  return rest;
}
